export default "__VITE_ASSET__C7fAawN5__"